<template>
  <div
    class="card bg-black rounded-2xl px-3 py-2 flex items-center shadow-lg relative overflow-hidden cursor-pointer hover:ring-2 hover:ring-primary"
    @click="goToProfile"
    :title="title"
  >
    <div>
      <div class="text-white font-semibold text-base text-left">{{ title }}</div>
      <div class="text-gray-300 text-xs text-left">
        {{ completionInfo.message || "Profilo completo" }}
      </div>
    </div>
    <div class="ml-auto flex items-center">
      <svg width="56" height="56" viewBox="0 0 56 56" class="block">
        <circle cx="28" cy="28" r="24" fill="none" stroke="#6C7278" stroke-width="5"/>
        <circle
          cx="28"
          cy="28"
          r="24"
          fill="none"
          stroke="#44D1BB"
          stroke-width="6"
          stroke-linecap="round"
          :stroke-dasharray="150.72"
          :stroke-dashoffset="150.72 - (150.72 * completionInfo.percent)"
          transform="rotate(-90 28 28)"
        />
        <text x="28" y="34" text-anchor="middle" fill="white" font-size="16" font-weight="bold">{{ Math.round(completionInfo.percent * 100) }}%</text>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileCompletionWidget",
  props: {
    title: {
      type: String,
      default: "Completamento profilo"
    },
    images: {
      type: Array,
      default: () => []
    },
    videos: {
      type: Array,
      default: () => []
    },
    goToProfile: {
      type: Function,
      required: true
    }
  },
  computed: {
    completionInfo() {
      const imagesCount = this.images.length;
      const videosCount = this.videos.length;
      let percent = 0.5;
      let message = "";
      // No images and no video
      if (imagesCount === 0 && videosCount === 0) {
        message = "Immagini e video presentazione mancanti";
        percent = 0.5;
      } else if (imagesCount >= 3 && videosCount === 0) {
        message = "Video presentazione mancante";
        percent = 0.75;
      } else if (imagesCount < 3 && imagesCount > 0 && videosCount === 0) {
        message = `Mancano ${3 - imagesCount} immagini e video presentazione`;
        percent = 0.5 + (imagesCount / 3) * 0.25;
      } else if (imagesCount === 0 && videosCount > 0) {
        message = "Mancano 3 immagini";
        percent = 0.75;
      } else if (imagesCount >= 3 && videosCount > 0) {
        message = "";
        percent = 1.0;
      } else if (imagesCount < 3 && imagesCount > 0 && videosCount > 0) {
        message = `Mancano ${3 - imagesCount} immagini`;
        percent = 0.75 + (imagesCount / 3) * 0.25;
      }
      return {
        percent,
        message
      };
    }
  }
}
</script>
